
    import {Component, Prop, Vue} from 'vue-property-decorator'
    import {getMerchantsLevelList, LevelListDto} from "@/api/customerManage";

    @Component({
        name: 'LevelFilters'
    })
    export default class LevelFilters extends Vue {
        @Prop({default: true}) isShowAll!: boolean // 是否显示所有级别
        @Prop({default: true}) isShowReset!: boolean // 是否显示清空
        @Prop({default: false}) isShowAdd!: boolean // 是否直接显示新增按钮
        @Prop({default: '客户级别筛选'}) title!: boolean // 标题
        @Prop({default: false}) isShowSetting!: boolean // 是否显示设置按钮
        @Prop({default: false}) isShop!: boolean // 是否是企业商城的设置

        showTemp = false
        companyId = ''
        levelList: LevelListDto[] = []
        levelId = ''

        mounted () {
            this.$eventBus.$on('levelAdd', (res: string) => {
                this.hide()
                this.getLevelList().then(()=>{
                  this.levelId = res
                  this.sureFunc()
                })
            })
        }

        getLevelList () {
            return  getMerchantsLevelList({companyId: this.companyId}).then((res) => {
                this.levelList = res.data.levelList || []
            })
        }

        show (options: { companyId: string, levelId: string }) {
            this.companyId = options.companyId
            this.levelId = options.levelId
            this.getLevelList()
            this.showTemp = true
        }

        hide () {
            this.showTemp = false
        }

        sureFunc () {
            const data = this.levelList.filter(item => { return item.levelId === this.levelId })
            this.$emit('getLevelId', this.levelId,  data && data.length > 0 ? data[0] : {})
            this.hide()
        }

        resetFunc () {
            this.levelId = ''
            this.$emit('getLevelId', this.levelId, {})
            this.hide()
        }

        changeTag (id: string) {
           this.levelId = id
        }

        toSetting () {
            this.hide()
            this.$nextTick(() => {
              if(this.isShop){
                this.$router.push('/shopLevelSetting')
              }else{
                this.$router.push('/levelSetting')
              }
            })
        }

        toAdd () {
            this.$router.push({
                path: '/levelHandle',
                query: {
                    isAdd: '1'
                }
            })
        }

        destroyed () {
            this.$eventBus.$off('levelAdd')
        }
    }
